"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyStatusResponseStatusEnum = exports.LoyaltyStatusResponseToJSON = exports.LoyaltyStatusResponseFromJSONTyped = exports.LoyaltyStatusResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function LoyaltyStatusResponseFromJSON(json) {
    return LoyaltyStatusResponseFromJSONTyped(json, false);
}
exports.LoyaltyStatusResponseFromJSON = LoyaltyStatusResponseFromJSON;
function LoyaltyStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': json['status'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.LoyaltyStatusResponseFromJSONTyped = LoyaltyStatusResponseFromJSONTyped;
function LoyaltyStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.LoyaltyStatusResponseToJSON = LoyaltyStatusResponseToJSON;
/**
* @export
* @enum {string}
*/
var LoyaltyStatusResponseStatusEnum;
(function (LoyaltyStatusResponseStatusEnum) {
    LoyaltyStatusResponseStatusEnum["NoConnection"] = "no_connection";
    LoyaltyStatusResponseStatusEnum["ConnectionEstablished"] = "connection_established";
    LoyaltyStatusResponseStatusEnum["ConnectionInactive"] = "connection_inactive";
    LoyaltyStatusResponseStatusEnum["ReauthenticationNeeded"] = "reauthentication_needed";
})(LoyaltyStatusResponseStatusEnum = exports.LoyaltyStatusResponseStatusEnum || (exports.LoyaltyStatusResponseStatusEnum = {}));
//# sourceMappingURL=LoyaltyStatusResponse.js.map